import block from 'bem-cn-lite';
import {FC} from 'react';
import {Text} from '@gravity-ui/uikit';
import {getActivatableProps, useMenuKeyboard} from '@hooks/keyboard';
import {loginAsClientFunc} from '../services/loginAsClientService';

import './PopupTypeEntrance.scss';

const b = block('login-as-client-popup-type-entrance');

interface PopupTypeEntranceProps {
    onClose: () => void;
    clientLogin: string | undefined;
    textClassName?: string;
    className?: string;
    clientPage?: boolean;
    onError?: (error: string) => void;
}

const MENU_ITEMS = ['prod', 'test'] as const;

export const PopupTypeEntrance: FC<PopupTypeEntranceProps> = ({
    onClose,
    clientLogin,
    textClassName,
    className,
    clientPage = false,
    onError
}) => {
    const handleLogin = async (host?: 'prod' | 'test') => {
        if (!clientLogin) return;

        const errorMessage = await loginAsClientFunc(clientLogin, host);

        if (errorMessage) {
            onError?.(errorMessage);
        }

        onClose();
    };

    const {highlightedIndex, setHighlightedIndex} = useMenuKeyboard<(typeof MENU_ITEMS)[number]>({
        isOpen: true,
        items: MENU_ITEMS,
        onSelect: (host) => {
            void handleLogin(host);
        },
        onClose
    });

    return (
        <div className={b(null, className)} role="menu">
            <div
                className={`${textClassName || ''} ${b('item', {highlighted: highlightedIndex === 0})}`}
                {...getActivatableProps(() => handleLogin('prod'), {role: 'menuitem'})}
                onFocus={() => setHighlightedIndex(0)}
            >
                <Text variant={clientPage ? 'body-1' : 'body-2'}>Войти под клиентом</Text>
            </div>
            <div
                className={`${textClassName || ''} ${b('item', {highlighted: highlightedIndex === 1})}`}
                {...getActivatableProps(() => handleLogin('test'), {role: 'menuitem'})}
                onFocus={() => setHighlightedIndex(1)}
            >
                <Text variant={clientPage ? 'body-1' : 'body-2'}>Войти под клиентом на ТЕСТ</Text>
            </div>
        </div>
    );
};
